import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import './Result.css';

class Result extends React.Component {

  render() {
    const { description, title, url } = this.props;

    return (
      <article>
        <div className="description">
          <h2>
            <a href={url} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />
          </h2>
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}></p>
          <p className="url">{url}</p>
        </div>
        <div className="clear"></div>
      </article>
    );
  }
}

export default Result;

Result.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Result.js